import React, { useState, useEffect } from "react";
import Axios from "axios";
import { baseUrl } from "../../config";
import { Table, Divider, Button } from "antd";
import { Link } from "react-router-dom";
import "./styles.scss";

const columns = [
  {
    title: "Gorsel",
    dataIndex: "bannerImage",
    key: "bannerImage",
    width: "10%",
    render: (text, render) => (
      <img
        alt={"banners"}
        style={{ width: "150px", height: "150px" }}
        src={render.bannerImage}
      ></img>
    ),
  },
  {
    title: "Baslik",
    dataIndex: "title",
    key: "title",
    render: (text, render) => (
      <Link to={`/blog/product/${render._id}`}>{text}</Link>
    ),
  },

  {
    title: "Action",
    key: "action",
    render: (text, record) => (
      <span>
        {/* <Link to={`/blog/${record._id}`}>Show</Link>
        <Divider type="horizontal" /> */}
        <Link to={`/blog/edit/${record._id}`}>
          <div
            style={{
              width: "100px",
              height: "40px",
              backgroundColor: "#2c3e50",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              borderRadius: "5px",
              boxShadow: "0px 5px 10px rgba(0, 0, 0, 0.12)",
            }}
          >
            <span style={{ color: "#fff", fontSize: "14px" }}>Düzenle </span>
          </div>
        </Link>
      </span>
    ),
  },
];

function App() {
  const [response, setResponse] = useState([]);
  useEffect(() => {
    Axios.get(baseUrl + "blog")
      .then((response) => {
        setResponse(response.data);
      })
      .catch(function (error) {});
  }, []);

  return (
    <div>
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "flex-end",
          padding: "50px 0",
        }}
      >
        <Link to="/blog/create">
          <div
            style={{
              width: "150px",
              height: "50px",
              backgroundColor: "#27ae60",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              borderRadius: "5px",
              boxShadow: "0px 5px 10px rgba(0, 0, 0, 0.12)",
            }}
          >
            <span style={{ color: "#fff", fontSize: "15px" }}>
              Yeni Blog Oluştur
            </span>
          </div>
        </Link>
      </div>
      <Table key={"allProductsTable"} columns={columns} dataSource={response} />
    </div>
  );
}

export default App;
